<template>
  <Wrapper>
    <Avatar slot="icon" :enableEdit="true" />
    <form v-on:submit.prevent="saveUsername">
      <FieldWrapper>
        <div slot="input">
          <input
            type="text"
            :value="user.username"
            @input="update"
            name="username"
            placeholder="Nickname"
            v-validate="validatorDefinitions.username"
            data-vv-scope="username"
          />
        </div>
        <div slot="errors" v-if="errors.has('username', 'username')">
          {{ errors.first("username", "username") }}
        </div>
      </FieldWrapper>
      <DecoratedButton :loading="loaders.username" name="save" type="submit">
        UPDATE NICKNAME
      </DecoratedButton>
    </form>
  </Wrapper>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Wrapper from "@/components/partials/profile/Wrapper";
import Avatar from "@/components/partials/profile/Avatar";

export default {
  name: "form-profile-login",
  components: { Wrapper, Avatar },
  data: function() {
    return {
      gravatarEmail: null
    };
  },
  computed: {
    ...mapGetters("user", {
      user: "getUser",
      avatar: "getAvatar",
      loaders: "getLoaders"
    }),
    isFormDirty() {
      return Object.keys(this.fields.$username).some(
        key => this.fields.$username[key].dirty
      );
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isFormDirty) {
      if (
        confirm(
          "You have some unsaved changes, are you sure you want to continue?"
        ) == true
      ) {
        next();
      }
    } else {
      next();
    }
  },
  methods: {
    ...mapActions("user", {
      updateUserAttribute: "updateUserAttribute",
      saveUserAttribute: "saveUserAttribute"
    }),
    resetForm(scope) {
      Object.keys(this.fields[scope]).some(
        key => (this.fields[scope][key].dirty = false)
      );
      setTimeout(() => {
        this.$validator.resume();
      }, 400);
    },
    update(e) {
      this.updateUserAttribute({
        attribute: e.target.name,
        value: e.target.value
      });
    },
    saveUsername() {
      this.$validator.validateAll("username").then(valid => {
        if (valid) {
          this.$validator.pause();
          this.saveUserAttribute({
            username: this.user.username
          });
          this.resetForm("$username");
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
